newWindow = () => {
  const links = document.querySelectorAll("a");
  links.forEach(link => {
      if (link.hostname !== window.location.hostname) {
        link.setAttribute('target','_blank')
        link.setAttribute('rel','noreferrer noopener')
      }
  })
}
newWindow()

dimensionCalc = (elem,id,key,property) => {  
  if (typeof (elem) != 'undefined' && elem != null) {
    let dimension = 0
    document.head.insertAdjacentHTML("beforeend", '<style id="'+ id +'"></style>')
    const stylesheet = document.getElementById(id)
    function calc() {
      if (property === 'height') {
        dimension = elem.offsetHeight
      } else if (property === 'width') {
        dimension = elem.offsetWidth
      }
      document.documentElement.classList.remove('has-scrolled')
      stylesheet.innerHTML = ':root {'+ key +': '+ dimension +'px}'
    }
    calc()
    window.addEventListener('resize', calc)
  }
}

navOnHover = () => {
    let items = document.querySelector(".header__inline-menu").querySelectorAll("details")
    items.forEach(item => {
      let summary = item.querySelector('summary'),
          href = summary.getAttribute('data-href')

      item.addEventListener("mouseover", () => {
        item.setAttribute("open", true)
        item.querySelector("ul").addEventListener("mouseleave", () => {
          item.removeAttribute("open")
        })

        summary.addEventListener('click', (e)=> {
          e.preventDefault()
          window.location.href = href
        })

      item.addEventListener("mouseleave", () => {
        item.removeAttribute("open")
      })
    })
  })
}
navOnHover()